import { render, staticRenderFns } from "./PanelContainer.vue?vue&type=template&id=32c55f5b&"
import script from "./PanelContainer.vue?vue&type=script&lang=js&"
export * from "./PanelContainer.vue?vue&type=script&lang=js&"
import style0 from "./PanelContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports